/**
 * Change email confirm page
 */

// React
import React from 'react';

// Libraries
import { useNavigate } from 'react-router-dom';

// MUI imports
import { Box, Button, Container, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

// Component
import AppLogo from 'components/AppLogo';

// Router
import ROUTES from 'configs/route';

// Styled
const ContainerCustom = styled(Container)({});

const LogoContainer = styled('div')({
  padding: '0 10px 40px 10px',
});

const WrapperChangeEmailForm = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
  gap: '30px',
}));

const WrapperContent = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '5px',
});

const ButtonCustom = styled(Button)({
  width: '40%',
  padding: '10px',
  border: 'none',
  borderRadius: 0,
  color: 'white',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '10px',
  maxWidth: '220px',
});

const TypographyCustom = styled(Typography)({
  fontWeight: '600',
  marginBottom: '0',
  paddingBottom: '4px',
});

const WrapperButton = styled(Box)({
  width: '100%',
  marginTop: '20px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  paddingBottom: '10px',
});

// Component
const ChangeEmailConfirmPage: React.FC = () => {
  const navigate = useNavigate();

  const handleClickBackPage = async () => {
    try {
      navigate(ROUTES.USER_INFO);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <ContainerCustom>
      <WrapperChangeEmailForm>
        <LogoContainer>
          <AppLogo />
        </LogoContainer>
        <WrapperContent>
          <TypographyCustom variant="h3">メールを送信しました</TypographyCustom>
          <TypographyCustom variant="h4">
            入力されたメールアドレスにメールを送信いたしましたので
          </TypographyCustom>
          <TypographyCustom variant="h4">
            URLにアクセスしてメールをリセットしてください
          </TypographyCustom>
        </WrapperContent>
        <WrapperButton>
          <ButtonCustom onClick={handleClickBackPage} variant="contained" color="primary">
            戻 る
          </ButtonCustom>
        </WrapperButton>
      </WrapperChangeEmailForm>
    </ContainerCustom>
  );
};

export default ChangeEmailConfirmPage;
